import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './StatusPage.css';

export function ForbiddenPage() {
  const { t } = useTranslation();

  return (
    <div className="fa-status-page">
      <p className="fa-status-page__code">403</p>
      <h1 className="fa-status-page__title">{t('errors.forbiddenTitle')}</h1>
      <p className="fa-status-page__body">{t('errors.forbiddenBody')}</p>
      <Link className="fa-status-page__link" to="/dashboard">
        {t('common.backToDashboard')}
      </Link>
    </div>
  );
}
